export const familyEn = {
  family: {
    nav: {
      title: 'Family',
    },
    page: {
      title: 'Family',
      subtitle: 'Manage your family, members and invitations',
    },
    onboarding: {
      title: 'Create your family',
      description: 'A family lets you share shopping lists and recipes. You will become its owner.',
      nameLabel: 'Family name',
      namePlaceholder: 'e.g. The Smiths',
      submit: 'Create family',
    },
    card: {
      title: 'Family',
      plan: 'Plan',
      members: 'Members',
      memberLimit: 'Member limit',
      unlimited: 'Unlimited',
    },
    plans: {
      free: 'Free',
      basic: 'Basic',
      pro: 'Pro',
    },
    roles: {
      owner: 'Owner',
      member: 'Member',
    },
    members: {
      title: 'Members',
      description: 'People who share this family',
      name: 'Name',
      email: 'Email',
      role: 'Role',
      joinedAt: 'Joined',
      remove: 'Remove',
      empty: 'No members yet',
      you: 'You',
    },
    invitations: {
      title: 'Invitations',
      description: 'Share a link to invite someone to your family',
      create: 'Create invitation link',
      limitReached: 'Member limit reached for your plan',
      copy: 'Copy link',
      copied: 'Link copied to clipboard',
      expiresAt: 'Expires',
      never: 'Never',
      empty: 'No active invitations',
      banner: {
        title: 'Family invitation',
        loading: 'Checking invitation…',
        description: 'You have been invited to join "{name}". Sign in to view the invitation and join.',
      },
    },
    accept: {
      title: 'Join family',
      description: 'You have been invited to join a family.',
      descriptionWithName: 'You have been invited to join "{name}".',
      joining: 'Joining…',
      accept: 'Accept invitation',
      decline: 'Not now',
      success: 'You joined the family',
      goToFamily: 'Go to family',
      errorTitle: 'Could not join',
      errors: {
        notFound: 'This invitation link is invalid.',
        expired: 'This invitation link has expired.',
        alreadyAccepted: 'This invitation has already been used.',
        alreadyInFamily: 'You are already a member of a family.',
        limitReached: 'The family has reached its member limit.',
        generic: 'Something went wrong while joining the family.',
      },
    },
    toasts: {
      created: 'Family created',
      createError: 'Could not create family',
      invitationCreated: 'Invitation link created',
      invitationError: 'Could not create invitation',
      memberLimitReached: 'Member limit reached for your plan',
      memberRemoved: 'Member removed',
      removeMemberError: 'Could not remove member',
    },
  },
}
